<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/J1asm5/tc-custom/9781614756477.jpg?1717877783518" alt="This image is the cover for the book Unnatural Hairy, Zomnibus Edition, Dan Shamble, Zombie P.I."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unnatural Hairy, Zomnibus Edition, Dan Shamble, Zombie P.I.
      </h1>
      <p class="bookDescription body article font2">
        <p>Together in one volume, two frighteningly hilarious Dan Shamble, Zombie P.I. adventures! UNNATURAL ACTS To be dead, or not to be dead… In the Unnatural Quarter, golems slave away in sweatshops, necromancers sell black-market trinkets to tourists, and the dead rise up—to work the night shift. But zombie detective Dan Shamble is no ordinary working stiff. When a local senator and his goons picket a ghostly production of Shakespeare in the Dark—condemning the troupe’s “unnatural” lifestyles—Dan smells something rotten. And if something smells rotten to a zombie, you’re in serious trouble…. Before his way of life, er, death is destroyed, Dan wants answers. Along the way, he needs to provide security for a mummified madame, defend a mixed-race couple (he’s a vampire, she’s a werewolf) from housing discrimination, and save his favorite watering hole, the Goblin Tavern, from drying up. Throw in a hairy hit-man and a bank robber who walks through walls, and Dan Shamble’s plate is full. Maybe this time the zombie detective has bitten off more than he can chew… HAIR RAISING The fur really flies when a serial scalper stalks the supernatural citizens of the Unnatural Quarter, targeting werewolves—and what's sadder than a bald lycanthrope? Dan Shamble, zombie P.I., is on the case, trying to stop an all-out gang war between full-time and full-moon werewolves. As he combs through the tangled clues to hunt down the bald facts, things get hairy fast. Shamble lurches through a loony landscape of voodoo tattoo artists, illicit cockatrice fights, body builders assembling make-your-own human kits, and perhaps scariest of all, crazed fans in town for the Worldwide Horror Convention. Yet the reign of hair-raising terror grows longer. If Shamble can't snip this off at the roots, the whole world could end up howling mad.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin J. Anderson
      </h2>
      
      <p class="authorDescription body article">Kevin J. Anderson has published more than 170 books, 58 of which have been national or international bestsellers. He has written numerous novels in the Star Wars, X-Files, and Dune universes, as well as unique steampunk fantasy novels Clockwork Angels andClockwork Lives, written with legendary rock drummer Neil Peart. His original works include the Saga of Seven Suns series, the Wake the Dragon and Terra Incognita fantasy trilogies, the Saga of Shadows trilogy, and his humorous horror series featuring Dan Shamble, Zombie PI. He has edited numerous anthologies, written comics and games, and the lyrics to two rock CDs. Anderson is the director of the graduate program in Publishing at Western Colorado University. Anderson and his wife Rebecca Moesta are the publishers of WordFire Press. His most recent novels are Vengewar, Dune: The Duke of Caladan (with Brian Herbert), Stake, Kill Zone (with Doug Beason), and Spine of the Dragon.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?93a50c00